module.exports = __webpack_public_path__ + "img/purchases.c92a9d15.svg";